import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChatLocalStorageService {
  setLastMessageIdInStorage(chat: number, id: number, date: string) {
    let localdata = localStorage.getItem(chat + '_date') ?? 0;
    let localTime = new Date(localdata).getTime();
    let newTime = new Date(date).getTime();
    if (localTime < newTime) {
      localStorage.setItem(chat + '_date', date);
      localStorage.setItem(chat + '_id', id + '');
    }
  }

  getLastMessageIdInStorage(chat: number) {
    return localStorage.getItem(chat + '_id') &&
      localStorage.getItem(chat + '_date')
      ? {
          id: Number(localStorage.getItem(chat + '_id')!),
          date: localStorage.getItem(chat + '_date')!,
        }
      : undefined;
  }
}
